export const deepCopy = (origin: any): any =>
  JSON.parse(JSON.stringify(origin));
